var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDarkRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#000"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.857 31.997H9.974A1.973 1.973 0 018 30.023v-4.258c0-1.091.883-1.975 1.974-1.975h5.61v-6.233c0-1.09.883-1.974 1.974-1.974h6.234v16.362h-4.936v.052z",
  fill: "#FFC517"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.031 31.997h-6.239V9.974c0-1.09.883-1.974 1.974-1.974h4.26C31.116 8 32 8.883 32 9.974v20.05c-.054 1.09-.929 1.973-1.969 1.973z",
  fill: "#F57E02"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.946 23.79v6.234c0 1.09-.883 1.974-1.974 1.974H23.74V15.584l8.207 8.207z",
  fill: "url(#dark-rounded_svg__paint0_linear_816_1346)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "dark-rounded_svg__paint0_linear_816_1346",
  x1: 23.766,
  y1: 23.791,
  x2: 31.954,
  y2: 23.791,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E96F0B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F37901"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9ImJsYWNrIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTguODU2NSAzMS45OTc1SDkuOTc0MkM4Ljg4MzExIDMxLjk5NzUgOCAzMS4xMTQ0IDggMzAuMDIzM1YyNS43NjQ2QzggMjQuNjczNSA4Ljg4MzExIDIzLjc5MDQgOS45NzQyIDIzLjc5MDRIMTUuNTg0VjE3LjU1NzRDMTUuNTg0IDE2LjQ2NjMgMTYuNDY3MSAxNS41ODMyIDE3LjU1ODIgMTUuNTgzMkgyMy43OTJWMzEuOTQ1NUgxOC44NTY1VjMxLjk5NzVaIiBmaWxsPSIjRkZDNTE3Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzAuMDMxNCAzMS45OTc1SDIzLjc5MlY5Ljk3NDE0QzIzLjc5MiA4Ljg4MzA1IDI0LjY3NTEgNy45OTk5NCAyNS43NjYyIDcuOTk5OTRIMzAuMDI1OEMzMS4xMTY5IDcuOTk5OTQgMzIgOC44ODMwNSAzMiA5Ljk3NDE0VjMwLjAyNDFDMzEuOTQ1NiAzMS4xMTQ0IDMxLjA3MTMgMzEuOTk3NSAzMC4wMzE0IDMxLjk5NzVaIiBmaWxsPSIjRjU3RTAyIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMzEuOTQ2IDIzLjc5MDhWMzAuMDIzOUMzMS45NDYgMzEuMTE0NyAzMS4wNjI5IDMxLjk5NzcgMjkuOTcyMSAzMS45OTc3SDIzLjczOVYxNS41ODM4TDMxLjk0NiAyMy43OTA4WiIgZmlsbD0idXJsKCNwYWludDBfbGluZWFyXzgxNl8xMzQ2KSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzgxNl8xMzQ2IiB4MT0iMjMuNzY2MyIgeTE9IjIzLjc5MDgiIHgyPSIzMS45NTM4IiB5Mj0iMjMuNzkwOCIgZ3JhZGllbnRVbml0cz0idXNlclNwYWNlT25Vc2UiPgo8c3RvcCBzdG9wLWNvbG9yPSIjRTk2RjBCIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0YzNzkwMSIvPgo8L2xpbmVhckdyYWRpZW50Pgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgDarkRounded as ReactComponent };